<template>
    <div>
        <div ref="searchBar" class="search-bar" :style="quadrado ? { 'border-radius' : '0px 20px 20px 0px' } : ''">
            <input
                class="text-field"
                ref="searchInput"
                type="text"
                spellcheck="false"
                :value="campo"
                :placeholder="placeholder"
                autocomplete="off"
                @input="atualizarValor"
                @keyup.enter="pesquisar()"
                @focus="mostrarMenu = true"
                :name="nameInput"
            />
            <MenuItem ref="menuItem" v-if="items.length > 0" @select="atualizarValorSelect" @index="i => $emit('selecionado', items[i])" style="top: 35px; background-color: #F1F2F1;" :largura="larguraMenuData" v-model="mostrarMenu" :items="items.map((el) => el.nome)" />
            <button
                class="button"
                @click="pesquisar()"
                :name="nameButton"
                >
                <icon name="search" :size="15"/>
            </button>
        </div>
    </div>
</template>

<script>
import MenuItem from './MenuItem'

export default {
  components: {
    MenuItem
  },
  props: {
    value: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    nameButton: {
      type: String
    },
    nameInput: {
      type: String
    },
    items: {
      type: Array,
      default: () => [],
      note: 'Array que contém os itens que serão mostrado em forma de lista.'
    },
    quadrado: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      campo: this.value,
      larguraMenuData: 0,
      mousedownListener: '',
      mostrarMenu: false
    }
  },
  watch: {
    value () {
      this.campo = this.value
    }
  },
  created () {
    this.$nextTick(() => {
      this.larguraMenuData = this.$refs['searchInput'].offsetWidth
    })
  },
  mounted () {
    this.mousedownListener = window.addEventListener('mousedown', ({ target }) => {
      const select = this.$refs['searchBar']
      if (select && !select.contains(target)) {
        this.removeSelecao()
      }
    }, false)
  },
  beforeDestroy () {
    window.removeEventListener('mousedown', this.mousedownListener)
  },
  methods: {
    removeSelecao () {
      this.mostrarMenu = false
    },
    pesquisar () {
      this.$emit('pesquisar', this.campo)
    },
    atualizarValorSelect (input) {
      this.$emit('selecionado')
      this.$emit('input', input)
    },
    atualizarValor () {
      this.campo = this.$refs.searchInput.value
      this.$emit('input', this.campo)
    },
    limparCampo () {
      this.campo = ''
    }
  }
}
</script>

<style lang="sass" scoped>
.search-bar
    position: relative
    width: 100%
    height: 35px
    border-radius: 20px
    background-color: #F1F2F1
    color: #54585e

    .text-field
        display: block
        float: left
        width: calc(100% - 38.42px)
        height: 100%
        border-radius: 20px 0px 0px 20px
        padding-left: 20px
        padding-right: 15px
        outline: 0
        text-overflow: ellipsis
        overflow: hidden
        white-space: nowrap

    .text-field::placeholder
        font-style: italic
        color: #afafaf

    .button
        display: block
        float: left
        width: 38.42px
        height: 35px
        border-radius: 20px
        background-color: #00995d
        color: #FFF
        cursor: pointer

</style>
